<template>
  <div>
    <apexchart
      type="pie"
      height="350"
      :options="options"
      :series="series"
    />
  </div>
</template>
<script>
export default {
  name: "apexchart-pie",
  props: {
    options: Object,
    series: Array
  }
};
</script>
